/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* ==================== UTILS ==================== */

const UTILS = {
  formatDateInFrench(date) {
    const options = { month: "long", day: "numeric" };
    return date.toLocaleDateString("fr-FR", options);
  },
  generateRandomId(length) {
    let result = "";
    const characters = "0123456789";
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * charactersLength);
      result += characters.charAt(randomIndex);
    }
    return result;
  },
};

class ExtimatedDate extends HTMLElement {
  constructor() {
    super();

    this.days = Number(this.dataset.days);

    if (this.days == 0)
      this.querySelector(".date").innerHTML =
        "Aujourd'hui (pour les commandes passées avant 15h)";
    else {
      this.date = new Date();
      this.estimatedDay = this.calculateShippingDate(this.date, this.days);
      this.querySelector(".date").innerHTML = UTILS.formatDateInFrench(
        this.estimatedDay
      );
    }
  }

  calculateShippingDate(date, days) {
    let addedDays = 0;
    let currentDay = new Date(date.getTime());

    while (addedDays < days) {
      currentDay.setDate(currentDay.getDate() + 1);
      if (currentDay.getDay() !== 0 && currentDay.getDay() !== 6) {
        addedDays++;
      }
    }

    return currentDay;
  }
}

customElements.define("estimated-date", ExtimatedDate);

/* ==================== CART DRAWER BANNER ==================== */

class CartDrawerBanner extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    // Get the required elements
    const bannerContainer = this;
    const banner = bannerContainer.querySelector(".bandeau-container");

    // Clone the banner content
    const bannerClone = banner.cloneNode(true);
    bannerContainer.appendChild(bannerClone);

    const bannerWidth = banner.clientWidth;
    let offset = 0;

    function moveBanner() {
      offset--;
      banner.style.transform = `translateX(${offset}px)`;
      bannerClone.style.transform = `translateX(${offset + bannerWidth}px)`;

      if (offset <= -bannerWidth) {
        offset = 0;
      }

      requestAnimationFrame(moveBanner);
    }

    moveBanner();
  }
}

customElements.define("cart-drawer-banner", CartDrawerBanner);

/* ==================== CART DRAWER ==================== */

jQuery(function () {
  // On récupère le panier en json
  const cart = fetch("/cart.js")
    .then((response) => response.json())
    .then((data) => {
      // On initialise Cart.js
      CartJS.init(data);
    });
});

const drawer = document.querySelector("cart-drawer");

function getCustomizationFromForm(form) {
  const context = form.closest(".Product__Info") || document;
  const checkedYesSelector =
    'input[name="personnalisation"][data-state="oui"]:checked';
  const yesInput =
    context.querySelector(checkedYesSelector) ||
    document.querySelector(checkedYesSelector);

  const contextNameInputs = Array.from(
    context.querySelectorAll(".custom-form-input")
  );
  const allNameInputs = Array.from(
    document.querySelectorAll(".custom-form-input")
  );
  const nameInput =
    contextNameInputs.find((input) => input.value.trim() !== "") ||
    allNameInputs.find((input) => input.value.trim() !== "") ||
    null;

  const variantInput =
    context.querySelector('input[id="personnalisationID"][value]') ||
    document.querySelector('input[id="personnalisationID"][value]');

  return {
    selected: Boolean(yesInput),
    name: nameInput?.value.trim() || "",
    variantId: variantInput?.value || "",
    price: Number(variantInput?.dataset.price || 0),
  };
}

async function addCustomProductWithoutCustomDrawer(form, customization) {
  const submitButton = form.querySelector('[type="submit"]');
  const initialHTML = submitButton?.innerHTML || "";
  const context = form.closest(".Product__Info") || document;
  const productId = form.querySelector('input[name="id"]')?.value || "";
  const productTitle =
    context.querySelector(".ProductMeta__Title")?.textContent.trim() ||
    document.querySelector(".ProductMeta__Title")?.textContent.trim() ||
    "";
  const quantity = Math.max(
    1,
    Number(form.querySelector('input[name="quantity"]')?.value || 1)
  );
  const root = window.Shopify?.routes?.root || "/";
  const ref = UTILS.generateRandomId(10);

  if (!productId || !customization.variantId || !customization.name) {
    window.alert("Les informations de personnalisation sont incomplètes.");
    return;
  }

  if (customization.price !== 1500) {
    window.alert(
      "La variante de personnalisation sélectionnée n'est pas celle à 15 €."
    );
    return;
  }

  if (submitButton) {
    submitButton.disabled = true;
    submitButton.innerHTML = "Ajout...";
  }

  try {
    const response = await fetch(`${root}cart/add.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        items: [
          {
            id: productId,
            quantity,
            properties: {
              Ref: ref,
              Personnalisation: customization.name,
            },
          },
          {
            id: customization.variantId,
            quantity,
            properties: {
              Produit: productTitle,
              Personnalisation: customization.name,
              Ref: ref,
            },
          },
        ],
      }),
    });
    const result = await response.json().catch(() => ({}));

    if (!response.ok) {
      throw new Error(
        result.description ||
          result.message ||
          "Shopify n'a pas pu ajouter la personnalisation."
      );
    }

    const customizationWasAdded =
      Array.isArray(result.items) &&
      result.items.some(
        (item) =>
          String(item.variant_id || item.id) ===
          String(customization.variantId)
      );

    if (!customizationWasAdded) {
      throw new Error(
        "La variante payante de personnalisation n'a pas été ajoutée."
      );
    }

    document.documentElement.dispatchEvent(
      new CustomEvent("cart:refresh", { bubbles: true })
    );
    document.documentElement.dispatchEvent(
      new CustomEvent("product:added", {
        bubbles: true,
        detail: { quantity },
      })
    );

    const cartLink = document.querySelector(
      '.Header__CartIcon, .Header a[href="/cart"], a[href="/cart"]'
    );
    cartLink?.click();
  } catch (error) {
    console.error("Erreur lors de l'ajout personnalisé :", error);
    window.alert(
      error?.message ||
        "Impossible d'ajouter ce produit au panier. Veuillez réessayer."
    );
  } finally {
    if (submitButton) {
      submitButton.disabled = false;
      submitButton.innerHTML = initialHTML;
    }
  }
}

/*
 * Un seul gestionnaire intercepte l'ajout depuis la fiche produit.
 * Il est enregistré en capture afin de passer avant le gestionnaire natif
 * du thème et d'éviter un double ajout.
 */
document.addEventListener(
  "submit",
  function (event) {
    const form = event.target.closest('form[action*="/cart/add"]');
    const cartDrawer = document.querySelector("cart-drawer");

    if (!form) {
      return;
    }

    const customization = getCustomizationFromForm(form);
    const hasCustomDrawer =
      cartDrawer &&
      typeof cartDrawer.handleAddToCartForm === "function";

    /*
     * Les formulaires sans personnalisation restent gérés par le thème
     * lorsqu'il n'existe pas de composant <cart-drawer>.
     */
    if (!customization.selected && !hasCustomDrawer) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    if (hasCustomDrawer) {
      void cartDrawer.handleAddToCartForm(form);
      return;
    }

    void addCustomProductWithoutCustomDrawer(form, customization);
  },
  true
);

// Ouverture du panier
document.querySelectorAll('.Header a[href="/cart"]').forEach((a) => {
  a.addEventListener("click", (e) => {
    e.preventDefault();
    drawer.openCartDrawer();
  });
});

// Fermeture du panier
document
  .querySelectorAll(".cart-drawer__header-close, .cart-drawer")
  .forEach((el) => {
    el.addEventListener("click", () => {
      drawer.closeCartDrawer();
    });
  });

class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.addDynamicEventListeners();
    this.addEventListeners();
  }

  getProductContext(form) {
    return form.closest(".Product__Info") || document;
  }

  getCustomization(form) {
    return getCustomizationFromForm(form);
  }

  setSubmitButtonLoading(button, isLoading, initialHTML = "") {
    if (!button) return;

    button.disabled = isLoading;
    button.innerHTML = isLoading
      ? '<img class="loading" src="https://cdn.shopify.com/s/files/1/0594/2833/9898/t/25/assets/loading.gif?v=1698766086" role="presentation" alt="">'
      : initialHTML;
  }

  async fetchJSON(url, options = {}) {
    const response = await fetch(url, options);
    const data = await response.json().catch(() => ({}));

    if (!response.ok) {
      throw new Error(
        data.description ||
          data.message ||
          "Shopify n'a pas pu mettre le panier à jour."
      );
    }

    return data;
  }

  async refreshCartAndOpen() {
    const root = window.Shopify?.routes?.root || "/";
    const cart = await this.fetchJSON(`${root}cart.js`, {
      headers: { Accept: "application/json" },
    });

    this.updateCartItemCounts(cart.item_count);
    await this.updateCart();
    this.openCartDrawer();
  }

  reportAddToCartError(error) {
    console.error("Erreur lors de l'ajout au panier :", error);
    window.alert(
      error?.message ||
        "Impossible d'ajouter ce produit au panier. Veuillez réessayer."
    );
  }

  async addProductToCart(form) {
    const submitButton = form.querySelector('[type="submit"]');
    const initialHTML = submitButton?.innerHTML || "";
    const root = window.Shopify?.routes?.root || "/";

    this.setSubmitButtonLoading(submitButton, true);

    try {
      await this.fetchJSON(`${root}cart/add.js`, {
        method: "POST",
        headers: { Accept: "application/json" },
        body: new FormData(form),
      });

      await this.refreshCartAndOpen();
    } catch (error) {
      this.reportAddToCartError(error);
    } finally {
      this.setSubmitButtonLoading(submitButton, false, initialHTML);
    }
  }

  async addCustomProductToCart(form, customization) {
    const submitButton = form.querySelector('[type="submit"]');
    const initialHTML = submitButton?.innerHTML || "";
    const context = this.getProductContext(form);
    const productId = form.querySelector('input[name="id"]')?.value || "";
    const productTitle =
      context.querySelector(".ProductMeta__Title")?.textContent.trim() || "";
    const quantity = Math.max(
      1,
      Number(form.querySelector('input[name="quantity"]')?.value || 1)
    );
    const ref = UTILS.generateRandomId(10);
    const root = window.Shopify?.routes?.root || "/";

    if (!productId || !customization.variantId || !customization.name) {
      this.reportAddToCartError(
        new Error("Les informations de personnalisation sont incomplètes.")
      );
      return;
    }

    if (customization.price !== 1500) {
      this.reportAddToCartError(
        new Error(
          "La variante de personnalisation sélectionnée n'est pas celle à 15 €."
        )
      );
      return;
    }

    this.setSubmitButtonLoading(submitButton, true);

    try {
      const result = await this.fetchJSON(`${root}cart/add.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          items: [
            {
              id: productId,
              quantity,
              properties: {
                Ref: ref,
                Personnalisation: customization.name,
              },
            },
            {
              id: customization.variantId,
              quantity,
              properties: {
                Produit: productTitle,
                Personnalisation: customization.name,
                Ref: ref,
              },
            },
          ],
        }),
      });

      const addedItems = Array.isArray(result.items) ? result.items : [];
      const customizationWasAdded = addedItems.some(
        (item) =>
          String(item.variant_id || item.id) ===
          String(customization.variantId)
      );

      if (!customizationWasAdded) {
        throw new Error(
          "L'option de personnalisation payante n'a pas été ajoutée."
        );
      }

      await this.refreshCartAndOpen();
    } catch (error) {
      this.reportAddToCartError(error);
    } finally {
      this.setSubmitButtonLoading(submitButton, false, initialHTML);
    }
  }

  async handleAddToCartForm(form) {
    const customization = this.getCustomization(form);

    if (customization.selected) {
      await this.addCustomProductToCart(form, customization);
      return;
    }

    await this.addProductToCart(form);
  }

  addEventListeners() {
    document
      .querySelectorAll(".cart-drawer__drawer, .cart-drawer__note")
      .forEach((el) => {
        el.addEventListener("click", (e) => {
          e.stopPropagation();
        });
      });
  }

  openCartDrawer() {
    document.body.style.overflow = "hidden";
    document.querySelector(".cart-drawer").classList.add("cart-drawer--active");
  }

  closeCartDrawer() {
    document.body.style.overflow = "auto";
    document
      .querySelector(".cart-drawer")
      .classList.remove("cart-drawer--active");
  }

  openCartNote() {
    document
      .querySelector(".cart-drawer__note")
      .classList.add("cart-drawer__note--active");
  }

  closeCartNote() {
    document
      .querySelector(".cart-drawer__note")
      .classList.remove("cart-drawer__note--active");

    // On récupère la note
    const note = document.querySelector("#cart-drawer-note").value;

    // Si la note est vide, on masque le bouton d'édition
    if (note === "") {
      document.getElementById("cart-drawer-activate-note").checked = false;
      document
        .querySelector(".cart-drawer__edit-note")
        .classList.remove("cart-drawer__edit-note--active");
    }
  }

  updateCartItemCounts(count) {
    document.querySelectorAll(".Header__CartCount").forEach((el) => {
      el.textContent = count;
    });
  }

  async updateCart() {
    const res = await fetch("/?snippet_id=cart-drawer-flow");
    const text = await res.text();

    this.removeCartDrawerDynamicListeners();

    const html = document.createElement("div");
    html.innerHTML = text;
    const newBox = html.querySelector(".cart-drawer__flow").innerHTML;
    document.querySelector(".cart-drawer__flow").innerHTML = newBox;

    this.addDynamicEventListeners();
  }

  addDynamicEventListeners() {
    // Update quantities
    document
      .querySelectorAll(".cart-drawer__quantity-selector button")
      .forEach((button) => {
        button.addEventListener("click", () => {
          this.handleQuantityButtonClick(button);
        });
      });

    // Delete product
    document
      .querySelectorAll(".cart-drawer__item-delete-product")
      .forEach((button) => {
        button.addEventListener("click", () => {
          this.handleDeleteClick(button);
        });
      });

    const cartDrawerOpenNote = document.getElementById(
      "cart-drawer-activate-note"
    );

    const cartDrawerEditNote = document.querySelector(
      ".cart-drawer__edit-note"
    );

    // Open note
    cartDrawerOpenNote?.addEventListener("change", (el) => {
      if (el.target.checked) {
        drawer.openCartNote();
      } else {
        drawer.closeCartNote();
        cartDrawerEditNote.classList.remove("cart-drawer__edit-note--active");
        // On supprime la note
        fetch(`${Shopify.routes.root}cart/update.js`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ note: "" }),
          keepalive: true,
        });
      }
    });

    cartDrawerEditNote?.addEventListener("click", () => {
      drawer.openCartNote();
    });

    // Close note
    const cartDrawerNoteClose = document.querySelector(
      ".cart-drawer__note-close"
    );

    cartDrawerNoteClose?.addEventListener("click", () => {
      drawer.closeCartNote();
    });

    document
      .getElementById("cart-drawer-note-form")
      .addEventListener("submit", (e) => {
        e.preventDefault();
        drawer.closeCartNote();
        cartDrawerEditNote.classList.add("cart-drawer__edit-note--active");
      });

    const cartDrawerNote = document.getElementById("cart-drawer-note");
    const cartDrawerNoteSubmit = document.querySelector(
      ".cart-drawer__note-form button"
    );

    cartDrawerNote.addEventListener("keyup", (e) => {
      cartDrawerNoteSubmit.classList.toggle(
        "button--disabled",
        e.target.value === ""
      );

      if (e.target.value === "") return;

      // Update note when typing
      fetch(`${Shopify.routes.root}cart/update.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ note: e.target.value.trim() }),
        keepalive: true,
        // Allows to make sure the request is fired even when submitting the form
      });
    });
  }

  removeCartDrawerDynamicListeners() {
    document
      .querySelectorAll(".cart-drawer-quantity-selector button")
      .forEach((button) => {
        button.removeEventListener("click", this.handleQuantityButtonClick);
      });

    document
      .querySelectorAll(".cart-drawer-item__delete-product")
      .forEach((button) => {
        button.removeEventListener("click", this.handleDeleteClick);
      });
  }

  async handleDeleteClick(button) {
    // Get line item key
    const rootItem = button.parentElement.parentElement.parentElement;
    const key = rootItem.getAttribute("data-line-item-key");

    let body;

    body = JSON.stringify({ updates: { [key]: 0 } });

    // Ajax update\
    const res = await fetch("/cart/update.js", {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: body,
    });

    const cart = await res.json();

    this.updateCartItemCounts(cart.item_count);

    // Update cart
    this.updateCart();
  }

  async handleQuantityButtonClick(button) {
    // Get line item key
    const rootItem =
      button.parentElement.parentElement.parentElement.parentElement
        .parentElement;

    // On récupère la key du produit
    const productKey = rootItem.getAttribute("data-line-item-key");
    let personnalisationProductKey = null;

    // On vérifie si on produit personnalisation est associé
    for (let item of rootItem.parentElement.querySelectorAll(
      "[data-line-item-key]"
    )) {
      if (item.getAttribute("data-line-item-parent-key") == productKey) {
        personnalisationProductKey = item.getAttribute("data-line-item-key");
        break;
      }
    }

    // Get new quantity
    const currentQuantity = Number(
      button.parentElement.querySelector("input").value
    );
    const isUp = button.classList.contains(
      "cart-drawer__quantity-selector-plus"
    );
    const newQuantity = isUp ? currentQuantity + 1 : currentQuantity - 1;

    let body;

    if (personnalisationProductKey) {
      // Si on a un produit à synchroniser, on applique la même modification de quantité que le produit associé
      body = JSON.stringify({
        updates: {
          [productKey]: newQuantity,
          [personnalisationProductKey]: newQuantity,
        },
      });
    } else {
      body = JSON.stringify({
        updates: { [productKey]: newQuantity },
      });
    }

    // Ajax update\
    const res = await fetch("/cart/update.js", {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: body,
    });

    const cart = await res.json();

    this.updateCartItemCounts(cart.item_count);

    // Update cart
    this.updateCart();
  }
}

customElements.define("cart-drawer", CartDrawer);

/* ================== CART DRAWER UPSELL ================== */

class CartDrawerUpsell extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.querySelector(".cart-drawer__upsell-arrow--left").addEventListener(
      "click",
      () => {
        alert("left");
      }
    );

    this.querySelector(".cart-drawer__upsell-arrow--right").addEventListener(
      "click",
      () => {
        alert("right");
      }
    );
  }
}

/* ================== PRODUCT SUGGESTION WRAP ================== */

class ProductSuggestionWrap extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.setSlider();
  }

  setSlider() {
    const slider = new Splide(this, {
      type: "slide",
      perPage: 3,
      gap: 25,
      arrows: true,
      pagination: false,
      breakpoints: {
        640: {
          perPage: 2,
        },
      },
    });
    slider.mount();
  }
}

customElements.define("product-suggestion-wrap", ProductSuggestionWrap);

/* ================== PRODUCT SUGGESTION ================== */

class ProductSuggestion extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.setEventListeners();
  }

  setEventListeners() {
    const form = this.querySelector("form");

    form.addEventListener("submit", async (e) => {
      e.preventDefault();

      // On ajoute un loader
      const submitInput = form.querySelector('*[type="submit"]');
      submitInput.innerHTML =
        '<img class="loading" src="https://cdn.shopify.com/s/files/1/0594/2833/9898/t/25/assets/loading.gif?v=1698766086" role="presentation">';

      // Submit form with ajax
      await fetch("/cart/add", {
        method: "post",
        body: new FormData(form),
      });

      document.querySelector(".cart-drawer").updateCart();
    });
  }
}

customElements.define("product-suggestion", ProductSuggestion);

/* ================== ONE CLICK PRODUCT ================== */
class CartDrawerOneClickProduct extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.form = this.querySelector("form");
    this.form.addEventListener("submit", async (e) => {
      e.preventDefault();
      // Submit form with ajax
      await fetch("/cart/add", {
        method: "post",
        body: new FormData(this.form),
      });
      document.querySelector(".cart-drawer").updateCart();
    });
  }

  disconnectedCallback() {
    this.form.removeEventListener("submit", this.handleSubmit);
  }
}

customElements.define(
  "cart-drawer-one-click-product",
  CartDrawerOneClickProduct
);

/* ================== PRODUCT CUSTOMIZATION ================== */

class ProductCustomizationWrap extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.currentName = "";

    this.inputID = document.querySelector(
      '.Product__Info form input[name="id"]'
    );
    this.productPrice = document.querySelector(
      ".ProductMeta__Price:not(.Price--compareAt)"
    );
    this.productPricePrecommande = document.querySelector(
      ".product-meta__price-item--precommande"
    );
    this.productATC = document.querySelector(".ProductForm__AddToCart");

    this.setEventListeners();
  }

  updatePrice() {
    this.productPrice.textContent = this.price;
    this.productATC.querySelector("span:last-of-type").textContent = this.price;
  }

  setEventListeners() {
    const customForm = this.querySelector(".custom-form");
    const customFormInput = this.querySelector(".custom-form-input");
    const customizationForm = this.querySelector("input#customNameInput");

    for (let choice of this.querySelectorAll(".product-customization-choice")) {
      choice.addEventListener("change", (e) => {
        this.price = e.target.dataset.price;
        this.updatePrice();

        const state = e.target.dataset.state;

        if (state === "oui") {
          // On affiche le formulaire
          customForm.classList.add("active");
          this.productPricePrecommande?.classList.add("active");
          customFormInput.required = true;

          // On affiche le nom gardé en mémoire
          customizationForm.value = this.currentName;
        } else if (state === "non") {
          // On cache le formulaire
          customForm.classList.remove("active");
          this.productPricePrecommande?.classList.remove("active");
          customFormInput.required = false;

          // On garde le nom en mémoire
          this.currentName = customizationForm.value;

          // On efface le nom pour ne pas qu'il s'ajoute au panier
          customizationForm.value = "";
        }
      });
    }
  }
}

customElements.define("product-customization-wrap", ProductCustomizationWrap);

/* ================== PREORDER COUNTER ================== */

class EditoCounter extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.countdownDate = new Date(
      this.getAttribute("data-estimated_date")
    ).getTime();
    this.setCounter();
    this.classList.add("edito-counter__counter--active");
  }

  updateCountdown() {
    const now = new Date().getTime();
    const difference = this.countdownDate - now;

    if (difference > 0) {
      // Calcul du temps restant
      const days = Math.floor(difference / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((difference % (1000 * 60)) / 1000);

      // Mise à jour de l'HTML
      this.querySelector(
        ".edito-counter__counter-item--days .edito-counter__counter-value"
      ).textContent = days;
      this.querySelector(
        ".edito-counter__counter-item--hours .edito-counter__counter-value"
      ).textContent = hours;
      this.querySelector(
        ".edito-counter__counter-item--minutes .edito-counter__counter-value"
      ).textContent = minutes;
      this.querySelector(
        ".edito-counter__counter-item--seconds .edito-counter__counter-value"
      ).textContent = seconds;
    } else {
      // Le compte à rebours est terminé
      clearInterval(this.interval);
    }
  }

  setCounter() {
    this.updateCountdown();
    // Mise à jour du compte à rebours toutes les secondes
    this.interval = setInterval(() => {
      this.updateCountdown();
    }, 1000);
  }
}

customElements.define("edito-counter", EditoCounter);

document.querySelectorAll(".ProductForm__Variants input")?.forEach((input) => {
  input.addEventListener("change", () => {
    setTimeout(() => {
      const basePrice = document.querySelector(
        ".ProductMeta__PriceList .ProductMeta__Price"
      ).textContent;
      const basePriceValue = parseFloat(
        basePrice.replace(/[^0-9,]/g, "").replace(",", ".")
      );
      const comparePrice = Math.round(basePriceValue + 10);

      const compareAtPriceElement = document.getElementById(
        "preorder-compare-at-price"
      );
      const priceElement = document.getElementById("preoder-price");

      if (compareAtPriceElement)
        compareAtPriceElement.textContent = comparePrice + "€";
      if (priceElement) priceElement.textContent = basePrice;
    }, 10);
  });
});